import axios from 'axios';

import { backendRequestHeaders, getBackendBaseUrl } from '@/api/backendAuth';

export async function fetchPaddleCustomerPortalUrl(sessionJwt?: string | null): Promise<string> {
  const base = getBackendBaseUrl();
  const { data } = await axios.post<{ url: string }>(`${base}/billing/paddle/customer-portal`, undefined, {
    headers: backendRequestHeaders(sessionJwt),
  });
  return data.url;
}
